import { render } from "./PaymentBox.vue?vue&type=template&id=1b067814"
import script from "./PaymentBox.vue?vue&type=script&lang=js"
export * from "./PaymentBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__